import React from 'react';
import Section from '../common/Section';
import { Brain, Activity, BookOpen, Sparkles } from 'lucide-react';

/**
 * Daily practice panel.
 */
const PillarsSection = () => {
  const cards = [
    { icon: Brain, title: 'Mind', text: 'Regulate and reflect' },
    { icon: Activity, title: 'Move', text: 'Gentle daily activity' },
    { icon: BookOpen, title: 'Journal', text: 'Private, always' },
    { icon: Sparkles, title: 'Faith', text: 'If it matters to you', optional: true },
  ];

  return (
    <Section id="pillars" background="white" padding="md" panel={false} className="pt-8" style={{ backgroundColor: 'var(--cream-canvas)' }}>
      <div
        className="max-w-6xl mx-auto rounded-[28px] border p-6 sm:p-8 md:p-10"
        style={{
          backgroundColor: 'var(--surface-card)',
          borderColor: 'rgba(31, 42, 36, 0.06)',
          boxShadow: '0 18px 38px rgba(20, 48, 36, 0.09)',
        }}
      >
        <div className="text-center mb-7">
          <h2 className="text-2xl sm:text-3xl font-extrabold mb-2" style={{ color: 'var(--text-primary)' }}>
            Your daily practice
          </h2>
          <p style={{ color: 'var(--text-muted)' }}>
            Three core practices a day. Faith is an optional fourth.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {cards.map(({ icon: Icon, title, text, optional }) => (
            <div
              key={title}
              className="rounded-3xl border p-5 sm:p-6 relative"
              style={{ backgroundColor: 'var(--surface-soft-1)', borderColor: 'rgba(31, 42, 36, 0.08)' }}
            >
              {optional && (
                <div className="absolute top-2 right-2 z-10">
                  <span
                    className="text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded-full"
                    style={{ backgroundColor: 'var(--brand-green-deep)', color: '#fff' }}
                  >
                    Optional
                  </span>
                </div>
              )}

              <div className="flex items-center gap-3">
                <div
                  className="w-11 h-11 rounded-2xl flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(45, 90, 71, 0.12)', color: 'var(--brand-green-deep)' }}
                >
                  <Icon size={22} />
                </div>
              </div>

              <h3 className="mt-4 text-lg font-extrabold" style={{ color: 'var(--text-primary)' }}>
                {title}
              </h3>
              <p className="mt-1 text-sm" style={{ color: 'var(--text-muted)' }}>
                {text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default PillarsSection;
